import { render, staticRenderFns } from "./DockerCard.vue?vue&type=template&id=56d9e212&scoped=true"
import script from "./DockerCard.vue?vue&type=script&lang=js"
export * from "./DockerCard.vue?vue&type=script&lang=js"
import style0 from "./DockerCard.vue?vue&type=style&index=0&id=56d9e212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9e212",
  null
  
)

export default component.exports